module.exports = __webpack_public_path__ + "img/2.ec4cb90e.jpg";